
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChooseSchemaComponent} from '../edit-schema/choose-schema.component';
import {Subject} from  'rxjs';
import {SchemaEditLanding} from '../edit-schema/location/schema-edit-landing.component';

@Component({
  selector: 'nuc-schema-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateSchemaComponent implements OnInit, OnDestroy {

  isEditStep = false;
  stepChangeSubject: Subject<boolean> = new Subject<boolean>();
  @ViewChild(ChooseSchemaComponent) stepOne: ChooseSchemaComponent;
  @ViewChild(SchemaEditLanding) stepTwo;
  constructor() { }

  ngOnInit() {
    this.stepChangeSubject
      .subscribe((response) => {
      this.isEditStep = response;
      this.stepOne.getCustomSchema(1);
      this.stepOne.getPredefinedSchema();
    });
  }
  ngOnDestroy() {
    this.stepChangeSubject.unsubscribe();
  }
  goToEditStep() {
    if (this.stepOne.canMoveForward()) {
      this.stepOne.onValidState(this.stepChangeSubject, true);
      return;
    }
    this.stepOne.onInvalidState();

  }

  saveSchema() {
    if (!this.stepTwo.canMoveForward()) {
      this.stepTwo.onInvalidState();
      return;
    }
    this.stepTwo.onValidState(this.stepChangeSubject, false);

  }

}




// WEBPACK FOOTER //
// ./src/app/schema/create/create.component.ts